import { render, staticRenderFns } from "./DoubleClickEditText.vue?vue&type=template&id=be2516a4&scoped=true&"
import script from "./DoubleClickEditText.vue?vue&type=script&lang=js&"
export * from "./DoubleClickEditText.vue?vue&type=script&lang=js&"
import style0 from "./DoubleClickEditText.vue?vue&type=style&index=0&id=be2516a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2516a4",
  null
  
)

export default component.exports